import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
const PIXEL_ID = '2222225874987302';

// Initialize Meta Pixel
!function (f, b, e, v, n, t, s) {
  if ((f as any).fbq) return;
  n = (f as any).fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!(f as any)._fbq) (f as any)._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = '2.0';
  n.queue = [];
  t = b.createElement(e);
  t.async = !0;
  (t as HTMLScriptElement).src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode!.insertBefore(t, s);
}(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
(window as any).fbq('init', PIXEL_ID);
(window as any).fbq('track', 'PageView');
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-328" data-mp="2tz4y6x2h2wr5" />);
}